export function FloatingFormula({ formula, className }) {
  return (
    <span className={`absolute font-mono text-white/[0.06] select-none pointer-events-none ${className}`}>
      {formula}
    </span>
  );
}

export function PiRing({ size = 200 }) {
  const r = (size - 16) / 2;
  const circ = 2 * Math.PI * r;
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id="piGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#7C3AED" />
            <stop offset="50%" stopColor="#3B82F6" />
            <stop offset="100%" stopColor="#06B6D4" />
          </linearGradient>
        </defs>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="8" />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="url(#piGrad)" strokeWidth="8" strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={circ * 0.1415} className="transition-all duration-[2s] ease-out" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="font-space text-6xl font-bold pi-gradient-text">&pi;</span>
      </div>
    </div>
  );
}
